import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { httpService } from "../../httpService";
import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import { ArrowBackIos } from "@mui/icons-material";

export default function CentresCandidates() {
  const [searchParams] = useSearchParams();
  const [centreDetail, setCentreDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [candidates, setCandidates] = useState([]);

  const centre = searchParams.get("centre");

  const examination = searchParams.get("examination");
  //console.log(searchParams.get("centre"));

  const navigate = useNavigate();
  const getData = async () => {
    setLoading(true);
    const { data } = await httpService("servermanager/examcentrecandidates", {
      params: { centre, examination },
    });

    if (data) {
      setCentreDetails(data.centre);
      setCandidates(data.candidates);
      console.log(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div>
      <div className="mt-1 mb-1">
        <Button startIcon={<ArrowBackIos />} onClick={() => navigate(-1)}>
          Go back
        </Button>
      </div>
      <div className="mt-4 mb-4">
        {loading && <CircularProgress />}

        <div className="alert alert-info border-0 mb-4">
          <Typography
            textTransform={"uppercase"}
            gutterBottom
            variant="h6"
            fontWeight={700}
          >
            {centreDetail?.name}
          </Typography>
          <Stack direction={"row"} spacing={3}>
            <Typography>Centre ID: {centreDetail?.centreId}</Typography>
            <Typography>State: {centreDetail?.state}</Typography>
          </Stack>
        </div>
        <div>
          <Table striped borderless>
            <thead>
              <tr>
                <th>S/N</th>
                <th>Name</th>
                <th>Examination Number</th>
                <th>School</th>
                <th>Question Category</th>
                <th>Session</th>
              </tr>
            </thead>
            <tbody>
              {candidates.map((c, i) => (
                <tr>
                  <td>{i + 1}</td>
                  <td>
                    <Typography>
                      {c.firstName} {c.lastName} {c.middleName}
                    </Typography>
                  </td>
                  <td>
                    <Typography textTransform={"uppercase"}>
                      {c.registrationNumber}
                    </Typography>
                  </td>
                  <td>
                    <Typography textTransform={"uppercase"}>
                      {c.school}
                    </Typography>
                  </td>
                  <td>{c.questionCategory}</td>
                  <td>
                    <Typography>{c.session}</Typography>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        {/* {report && (
          <div>
            
            
            <div className="mt-4">
              <div className="mt-2 mb-2">
                <div className="row">
                  <div className="col-lg-3 alert alert-info me-2">
                    <Typography variant="body1" component="p">
                      First Session: <strong>{session1}</strong>
                    </Typography>
                  </div>
                  <div className="col-lg-3 alert alert-danger">
                    <Typography variant="body1" component="p">
                      Second Session: <strong>{session2}</strong>
                    </Typography>
                  </div>
                </div>
              </div>
            
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
}
